/*
 * ELLIZ size guide drawer logic.
 * Resolves a guide from product.type + tags (accent-insensitive), renders the
 * "Είδος" (garment) and "Σώμα" (body) tables and runs the height/weight calculator.
 * CM only (inch toggle removed). Shows ONLY the sizes the product actually offers
 * (data-product-sizes); falls back to all rows if none match.
 * Data: assets/elliz-size-guides.json
 */
(function () {
  if (window.__ellizSgInit) return;
  window.__ellizSgInit = true;

  function normalize(s) {
    return (s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  /* Urun bedenlerini karsilastirma anahtarlarina acar (2026-07-03):
     - "2XL"/"3XL" takma adlari XXL/XXXL satirlariyla eslesir,
     - "40-41" / "S-M" gibi ARALIK bedenleri iki ucuna acilir -> terlikler
       tekli 40+41 satirlarini, S-M urunler S+M satirlarini gorur. */
  function sizeTokens(list) {
    var out = [];
    (list || []).forEach(function (raw) {
      var s = String(raw).trim().toUpperCase();
      if (!s) return;
      if (s === "2XL") s = "XXL";
      if (s === "3XL") s = "XXXL";
      out.push(s);
      var parts = s.split("-");
      if (parts.length === 2 && parts[0].trim() && parts[1].trim()) {
        var a = parts[0].trim(), b = parts[1].trim();
        if (a === "2XL") a = "XXL";
        if (b === "2XL") b = "XXL";
        out.push(a);
        out.push(b);
      }
    });
    return out;
  }

  function resolveGuideKey(data, type, tags) {
    var hay = normalize(type + " " + tags.join(" "));
    for (var i = 0; i < data.rules.length; i++) {
      var rule = data.rules[i];
      for (var j = 0; j < rule.match.length; j++) {
        if (hay.indexOf(normalize(rule.match[j])) !== -1) return rule.key;
      }
    }
    return data.default || "bottomwear";
  }

  function getGuide(data, key) {
    var g = data.guides[key] || data.guides[data.default];
    if (!g) return null;
    if (g.extends && data.guides[g.extends]) {
      var base = data.guides[g.extends];
      return {
        title: g.title || base.title,
        category: g.category || base.category,
        item: g.item || base.item,
        body: g.body || base.body,
        weight: g.weight || base.weight,
      };
    }
    return g;
  }

  // all size labels a guide knows about (weight + item/body first column)
  // weight can be an array (numbered jeans) OR an object keyed by max size {L,XL,XXL} (lettered)
  function weightRowsAll(w) {
    if (!w) return [];
    if (Array.isArray(w)) return w;
    var out = [];
    Object.keys(w).forEach(function (k) { (w[k] || []).forEach(function (r) { out.push(r); }); });
    return out;
  }

  // pick the right weight table for this product, by its largest lettered size (XXL product -> XXL table, XL-max -> XL table)
  function pickWeight(guide, sizes) {
    var w = guide.weight;
    if (!w) return null;
    if (Array.isArray(w)) return w;
    var order = ["S", "M", "L", "XL", "XXL"];
    var mi = -1, maxSize = null;
    (sizes || []).forEach(function (s) { var i = order.indexOf(s); if (i > mi) { mi = i; maxSize = s; } });
    if (maxSize && w[maxSize]) return w[maxSize];
    var keys = Object.keys(w).filter(function (k) { return order.indexOf(k) !== -1; })
      .sort(function (a, b) { return order.indexOf(a) - order.indexOf(b); });
    if (!keys.length) return null;
    if (mi < 0) return w[keys[keys.length - 1]];
    var best = keys[0];
    keys.forEach(function (k) { if (order.indexOf(k) <= mi) best = k; });
    return w[best];
  }

  function guideSizes(g) {
    var s = [];
    weightRowsAll(g.weight).forEach(function (w) { s.push(String(w.size).trim().toUpperCase()); });
    if (g.item && g.item.rows) g.item.rows.forEach(function (r) { s.push(String(r[0]).trim().toUpperCase()); });
    if (g.body && g.body.rows) g.body.rows.forEach(function (r) { s.push(String(r[0]).trim().toUpperCase()); });
    return s;
  }
  function guideMatchesSizes(g, sizes) {
    if (!sizes || !sizes.length) return true;
    var gs = guideSizes(g);
    return sizes.some(function (s) { return gs.indexOf(String(s).trim()) !== -1; });
  }

  function headerLabel(col) {
    return col.unit ? col.label + " (εκ.)" : col.label;
  }

  // keep only rows whose first cell (size) is in the product's available sizes; fall back to all
  function filterRows(rows, sizes) {
    if (!rows || !sizes || !sizes.length) return rows || [];
    var f = rows.filter(function (r) { return sizes.indexOf(String(r[0]).trim().toUpperCase()) !== -1; });
    return f.length ? f : rows;
  }

  // same idea for weight rows ({min,max,size})
  function filterWeights(rows, sizes) {
    if (!rows || !sizes || !sizes.length) return rows || [];
    var f = rows.filter(function (r) { return sizes.indexOf(String(r.size).trim().toUpperCase()) !== -1; });
    return f.length ? f : rows;
  }

  function tableHtml(spec, sizes) {
    if (!spec || !spec.columns) return "";
    var h = "<table class='elliz-sg-table'>";
    if (spec.caption) h += "<caption>" + spec.caption + "</caption>";
    h += "<thead><tr>";
    spec.columns.forEach(function (c) { h += "<th>" + headerLabel(c) + "</th>"; });
    h += "</tr></thead><tbody>";
    filterRows(spec.rows || [], sizes).forEach(function (row) {
      h += "<tr>";
      row.forEach(function (cell) { h += "<td>" + cell + "</td>"; });
      h += "</tr>";
    });
    return h + "</tbody></table>";
  }

  function weightSize(rows, kg) {
    if (!rows || !rows.length) return "-";
    for (var i = 0; i < rows.length; i++) {
      if (kg >= rows[i].min && kg <= rows[i].max) return rows[i].size;
    }
    return kg < rows[0].min ? rows[0].size : rows[rows.length - 1].size;
  }

  // weight rows ({min,max,size}) -> "Βάρος (kg) | Προτεινόμενο μέγεθος" table
  function weightTableHtml(rows, sizes) {
    if (!rows || !rows.length) return "";
    var fr = filterWeights(rows, sizes);
    var h = "<table class='elliz-sg-table'><thead><tr><th>Βάρος (kg)</th><th>Προτεινόμενο μέγεθος</th></tr></thead><tbody>";
    fr.forEach(function (r) { h += "<tr><td>" + r.min + " - " + r.max + "</td><td>" + r.size + "</td></tr>"; });
    return h + "</tbody></table>";
  }

  function renderTables(container) {
    var st = container._ellizSg;
    if (!st) return;
    var weightWrap = container.querySelector("[data-elliz-sg-weight-table]");
    var bodyWrap = container.querySelector("[data-elliz-sg-body-table]");
    if (weightWrap) weightWrap.innerHTML = weightTableHtml(pickWeight(st.guide, st.sizes), st.sizes);
    if (bodyWrap && !st.embedded) bodyWrap.innerHTML = tableHtml(st.guide.body, st.sizes);
  }

  function setTabAvailable(drawer, name, ok) {
    var tab = drawer.querySelector("[data-elliz-sg-tab='" + name + "']");
    if (tab) tab.hidden = !ok;
    if (!ok) {
      var pane = drawer.querySelector("[data-elliz-sg-pane='" + name + "']");
      if (pane) pane.hidden = true;
    }
  }

  function selectTab(drawer, name) {
    drawer.querySelectorAll("[data-elliz-sg-tab]").forEach(function (t) {
      t.classList.toggle("is-active", t.getAttribute("data-elliz-sg-tab") === name);
    });
    drawer.querySelectorAll("[data-elliz-sg-pane]").forEach(function (p) {
      p.hidden = p.getAttribute("data-elliz-sg-pane") !== name;
    });
  }

  function showOne(container, attr, value, fallback) {
    var nodes = container.querySelectorAll("[" + attr + "]");
    var matched = false;
    nodes.forEach(function (n) {
      var on = n.getAttribute(attr) === value;
      n.hidden = !on;
      if (on) matched = true;
    });
    if (!matched && fallback) {
      nodes.forEach(function (n) { n.hidden = n.getAttribute(attr) !== fallback; });
    }
  }

  function setup(container, data) {
    var type = container.getAttribute("data-product-type") || "";
    var tags = (container.getAttribute("data-product-tags") || "").split(",").map(function (t) { return t.trim(); });
    var sizes = (container.getAttribute("data-product-sizes") || "").split(",").map(function (s) { return s.trim(); }).filter(Boolean);
    sizes = sizeTokens(sizes);
    var guideKey = resolveGuideKey(data, type, tags);
    var guide = getGuide(data, guideKey);
    if (!guide) return;
    // Size-type safety net: when the product's sizes don't match the resolved guide,
    // fall back to a guide of the RIGHT size-type.
    //  - a lettered product (S/M/L..) that resolved to a numbered jean guide -> lettered category guide;
    //  - a NUMERIC product (29/30..) that resolved to a lettered bottom guide (a denim Βερμούδα forced
    //    to lettered "shorts", or a numeric cotton Παντελόνι) -> a NUMBERED guide via the resolved
    //    guide's "numericAlt" (default jeans_loose). Lettered fallbacks alone can't rescue numeric sizes.
    if (sizes.length && !guideMatchesSizes(guide, sizes)) {
      var sizesNumeric = sizes.some(function (s) { return /^\d+$/.test(s); });
      var rawGuide = data.guides[guideKey] || {};
      var fbKey;
      if (sizesNumeric && guide.category === "bottom") {
        fbKey = rawGuide.numericAlt || "jeans_loose";
      } else {
        fbKey = guide.category === "top" ? "topwear" : (guide.category === "shoes" ? "shoes" : "bottomwear");
      }
      var fbGuide = getGuide(data, fbKey);
      if (fbGuide && guideMatchesSizes(fbGuide, sizes)) guide = fbGuide;
    }
    // Big even-numbered chino sizing (only BOTTOM products that offer 42 or 44): dedicated
    // kg-only table, kept separate from the jean/denim tables. Title follows the garment
    // (Βερμούδες for shorts-type, Παντελόνια otherwise). Shoes also carry 42/44 as EU shoe
    // numbers, so this must never fire outside the "bottom" category.
    if (guide.category === "bottom" && (sizes.indexOf("42") !== -1 || sizes.indexOf("44") !== -1)) {
      var chino = data.guides.chino_large;
      if (chino && chino.weight) {
        guide = {
          title: guideKey === "shorts" ? "Βερμούδες" : "Παντελόνια",
          category: "bottom",
          weight: chino.weight,
        };
      }
    }
    var category = guide.category || "bottom";

    container._ellizSg = {
      guide: guide,
      sizes: sizes,
      embedded: container.getAttribute("data-embedded-guide") === "1",
    };

    var titleEl = document.querySelector("[data-elliz-sg-guide-title]");
    if (titleEl && guide.title) titleEl.textContent = guide.title;

    if (container._ellizSg.embedded) {
      var bw = container.querySelector("[data-elliz-sg-body-table]");
      if (bw) bw.hidden = true;
    }

    renderTables(container);

    var bodyDiag = category === "shoes" ? "shoes" : (category === "bottom" ? "bottom" : "body");
    showOne(container, "data-elliz-sg-bodydiagram", bodyDiag, "body");

    // Show only the tabs that actually have data; activate the first available one.
    var drawerTabs = container.closest("[data-elliz-sg-drawer]") || document;
    var wPick = pickWeight(guide, sizes);
    var hasWeight = !!(wPick && filterWeights(wPick, sizes).length);
    var hasDims = container._ellizSg.embedded ||
      !!(guide.body && guide.body.rows && filterRows(guide.body.rows, sizes).length);
    setTabAvailable(drawerTabs, "weight", hasWeight);
    setTabAvailable(drawerTabs, "dims", hasDims);
    var both = hasWeight && hasDims;
    var toolbar = drawerTabs.querySelector(".elliz-sg-toolbar");
    var tablabel = drawerTabs.querySelector(".elliz-sg-tablabel");
    if (toolbar) toolbar.style.display = both ? "" : "none";
    if (tablabel) tablabel.style.display = both ? "" : "none";
    selectTab(drawerTabs, hasWeight ? "weight" : "dims");

    var drawer = container.closest("[data-elliz-sg-drawer]") || document;
    var calc = drawer.querySelector("[data-elliz-sg-calc]");
    var rec = drawer.querySelector("[data-elliz-sg-rec]");
    var w = drawer.querySelector("[data-elliz-weight]");
    var wRows = pickWeight(guide, sizes);
    wRows = wRows ? filterWeights(wRows, sizes) : null;
    if (wRows && wRows.length && calc && rec && w) {
      calc.hidden = false;
      var update = function () { rec.textContent = weightSize(wRows, parseInt(w.value, 10) || 0); };
      w.addEventListener("input", update);
      var ht = drawer.querySelector("[data-elliz-height]");
      if (ht) ht.addEventListener("input", update);
      update();
    } else if (calc) {
      calc.hidden = true;
    }
  }

  function openDrawer(d) {
    if (d.parentElement !== document.body) document.body.appendChild(d);
    d.hidden = false;
    document.body.style.overflow = "hidden";
  }
  function closeDrawer(d) { d.hidden = true; document.body.style.overflow = ""; }

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-elliz-sg-open]")) {
      var d = document.querySelector("[data-elliz-sg-drawer]");
      if (d) openDrawer(d);
      return;
    }
    if (e.target.closest("[data-elliz-sg-close]")) {
      var dc = e.target.closest("[data-elliz-sg-drawer]");
      if (dc) closeDrawer(dc);
      return;
    }
    var tab = e.target.closest("[data-elliz-sg-tab]");
    if (tab) {
      var name = tab.getAttribute("data-elliz-sg-tab");
      var panel = tab.closest("[data-elliz-sg-drawer]");
      panel.querySelectorAll("[data-elliz-sg-tab]").forEach(function (t) { t.classList.toggle("is-active", t === tab); });
      panel.querySelectorAll("[data-elliz-sg-pane]").forEach(function (p) { p.hidden = p.getAttribute("data-elliz-sg-pane") !== name; });
      return;
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      var d = document.querySelector("[data-elliz-sg-drawer]:not([hidden])");
      if (d) closeDrawer(d);
    }
  });

  function init() {
    var drawer = document.querySelector("[data-elliz-sg-drawer]");
    if (drawer && drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }
    // JSON adresini drawer'in data-elliz-sg-data'sindan (Liquid asset_url -> kendi
    // ?v= surumu) al; yoksa eski yontem. script.src.replace tuzagi: JS degismeyince
    // JSON eski ?v= ile istenir ve CDN bayat JSON dondurur (2026-07-02'de yasandi).
    var script = document.querySelector('script[src*="elliz-size-guide.js"]');
    var dataUrl = drawer && drawer.getAttribute("data-elliz-sg-data");
    if (!dataUrl && !script) return;
    fetch(dataUrl || script.src.replace("elliz-size-guide.js", "elliz-size-guides.json"))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        document.querySelectorAll("[data-elliz-sg-body]").forEach(function (c) { setup(c, data); });
      })
      .catch(function () {});
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
